export default __webpack_public_path__ + "static/media/icon-add-user.653f5495.svg";